import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CryptoTradingApp from './components/CryptoTradingApp';
import WalletsPanel from './components/WalletsPanel';
import LoginGate, { AUTH_FLAG } from './components/LoginGate';

// One panel, three pages. All three trade from the same server-side wallet;
// only the token differs. Trade history is shared (see /api/history).
//
// A single admin login gates the whole app. Once entered it's stored per-origin,
// so /payu, /irena and /aifx are all unlocked together and survive reloads.
function App() {
  const [authed, setAuthed] = useState(() => {
    try { return localStorage.getItem(AUTH_FLAG) === '1'; } catch (e) { return false; }
  });

  if (!authed) {
    return (
      <div className="App">
        <LoginGate onSuccess={() => setAuthed(true)} />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* `key` forces a remount per token so per-token state (amount,
              slippage, interval) is re-initialised instead of carried over. */}
          <Route path="/payu" element={<CryptoTradingApp key="payu" tokenKey="payu" />} />
          <Route path="/irena" element={<CryptoTradingApp key="irena" tokenKey="irena" />} />
          <Route path="/aifx" element={<CryptoTradingApp key="aifx" tokenKey="aifx" />} />
          <Route path="/hermes" element={<CryptoTradingApp key="hermes" tokenKey="hermes" />} />
          <Route path="/ride" element={<CryptoTradingApp key="ride" tokenKey="ride" />} />
          <Route path="/maradona" element={<WalletsPanel />} />
          <Route path="*" element={<Navigate to="/payu" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
